<template>
    <div v-if="showEditLayer">
        <h5 class="edit_header col s10" >
            <span class="header_project_name">{{ current_project.name }}</span>
        </h5>
<!--        <v-dialog v-model="dialog_layer_add" width="500" dark overlay-opacity=".5" overlay-color="#333">-->
<!--            <v-card>-->
<!--                <v-card-title class="headline dark justify-center">-->
<!--                    Please, enter layer name-->
<!--                </v-card-title>-->
<!--                <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="addNewLayer">-->
<!--                    <v-card-text>-->
<!--                        <v-col cols="12">-->
<!--                            <v-text-field v-model="newLayerName" :rules="nameRules" label="Layer Name" hint="Please enter layer name" required></v-text-field>-->
<!--                        </v-col>-->
<!--                    </v-card-text>-->
<!--                    <v-divider></v-divider>-->
<!--                    <v-card-actions >-->
<!--                        <v-spacer></v-spacer>-->
<!--                        <v-btn color="teofly_orange" text dark type="submit">Add Layer</v-btn>-->
<!--                        <v-btn color="grey" text dark @click="dialog_layer_add = false">Cancel</v-btn>-->
<!--                    </v-card-actions>-->
<!--                </v-form>-->
<!--            </v-card>-->
<!--        </v-dialog>-->
      <v-dialog v-model="dialog_layer_add" width="500" dark overlay-opacity=".5" overlay-color="#333">
        <v-card>
          <v-card-title class="headline dark justify-center">
            Add new layer
          </v-card-title>
          <v-card-text>
            <v-col cols="12" class="text-center">
              <p class="text-h5 pink--text">Project moved to read mode</p>
              <p class="text-subtitle-1">For full-fledged work, go to our new project <a href="https://gis.teofly.com">https://gis.teofly.com</a>.</p>

            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>

        <v-col cols="11" class="p-0">

            <p>{{ current_project.description }}</p>

            <v-divider></v-divider>

            <div class="project_descr_item">
                <div class="project_descr_item_body">
                    Share:
                    <span class="teofly-color">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <span class="teofly-color" @click="shared_click">
                                <i v-bind="attrs" v-on="on" v-if="current_project.is_shared == 0" title="Not Shared" class="v-icon mdi mdi-link-off"></i>
                                <i v-bind="attrs" v-on="on" v-else-if="current_project.is_shared == 1 && (current_project.shared_password == '' || current_project.shared_password == null)" title="Shared" class="v-icon mdi mdi-link"></i>
                                <i v-bind="attrs" v-on="on" v-else title="Shared with Password" class="v-icon mdi mdi-link-lock"></i>
                                </span>
                            </template>

                            <span v-if="current_project.is_shared == 0">Not Shared</span>
                            <span v-else-if="current_project.is_shared == 1 && (current_project.shared_password == '' || current_project.shared_password == null)">Shared</span>
                            <span v-else>Shared with Password</span>

                        </v-tooltip>
                    </span>
                </div>
            </div>

            <div class="project_descr_item">
                <div class="project_descr_item_body">
                    Usage: <span>{{ formatBytes(current_project.space_use) }}</span> <small>(Left: <span :class="{error_quota : user.space_use >= user.space_quota}">{{ formatBytes(user.space_quota - user.space_use) }}</span>)</small>
                </div>
            </div>

            <div class="project_descr_item">
                <div class="project_descr_item_body project_descr_item_body_icons">

                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div><i v-bind="attrs" v-on="on" title="Images" class="v-icon mdi mdi-image-area"></i> <span>{{ current_project.count_image_files }}</span></div>
                        </template>
                        <span>Images in Project</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div><i v-bind="attrs" v-on="on" title="Video" class="v-icon mdi mdi-youtube"></i>  <span>{{ current_project.count_video_files }}</span></div>
                        </template>
                        <span>Videos in Project</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div><i v-bind="attrs" v-on="on" title="Panoramas" class="v-icon mdi mdi-panorama-horizontal"></i> <span>{{current_project.count_panorama_files }}</span></div>
                        </template>
                        <span>Panoramas in Project</span>
                    </v-tooltip>

                </div>
            </div>

            <v-divider></v-divider>

            <div class="project_buttons_item">

                <v-dialog
                    v-model="dialog_edit"
                    width="500"
                    dark
                    overlay-opacity=".5"
                    overlay-color="#333"
                    @click:outside="cancelNewProject"
                >
                    <template v-slot:activator="{ on: dialog, attrs }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn fab dark small v-bind="attrs" v-on="{ ...tooltip, ...dialog }" class="edit_project_button green mr-2">
                                    <i class="v-icon mdi mdi-square-edit-outline"></i>
                                </v-btn>
                            </template>
                            <span>Edit Project</span>
                        </v-tooltip>
                    </template>
                    <v-card>
                        <v-card-title class="headline dark justify-center">
                            Edit Project
                        </v-card-title>
                        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="updateNewProject">
                            <v-card-text>
                                <v-col cols="12">
                                        <v-text-field v-model="newProjectName" :rules="nameRules" label="Project Name" hint="Please enter project name" required></v-text-field>
                                        <v-textarea label="Project Description" hint="Please enter project description" type="text" v-model="newProjectDescription"></v-textarea>
                                </v-col>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions >
                                <v-spacer></v-spacer>
                                <v-btn color="teofly_orange" text dark type="submit">Update Project</v-btn>
                                <v-btn color="grey" text dark @click="cancelNewProject">Cancel</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>

                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" fab dark small @click="addLayerOpen()" class="add_layer_button blue mr-2">
                            <i class="v-icon mdi mdi-plus-box-multiple-outline"></i>
                        </v-btn>
                    </template>
                    <span>Add New Layer to the Project</span>
                </v-tooltip>

                <v-dialog
                    v-model="dialog_share"
                    width="800"
                    dark
                    overlay-opacity=".5"
                    overlay-color="#333"
                >
                    <template v-slot:activator="{ on: dialog, attrs }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn fab dark small v-bind="attrs" v-on="{ ...tooltip, ...dialog }" @click="prepareShared" title="Share Project" class="share_project_button orange mr-2">
                                    <i class="v-icon mdi mdi-share-all-outline"></i>
                                </v-btn>
                            </template>
                            <span>Share Project</span>
                        </v-tooltip>
                    </template>
                    <v-card>
                        <v-card-title class="headline dark justify-center">
                            Share Project
                        </v-card-title>
                        <v-card-text>
                            <v-col cols="12">
                                <v-form ref="form_share" v-model="valid" lazy-validation class="share_input">
                                    <v-text-field v-model="shared_url" label="Share Link" readonly>
                                        <template v-slot:append>
                                            <i @click="copyToClipboard(shared_url)" class="material-icons">content_copy</i>
                                        </template>
                                    </v-text-field>
                                    <v-text-field class="shared_pass_block" :class="{active : is_share_pass}" v-model="shared_password" :rules="passwordRules" label="Password" v-bind:readonly="current_project.is_shared == 1" ></v-text-field>
                                </v-form>
                            </v-col>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="pl-8">
                            <v-switch
                                v-bind:readonly="current_project.is_shared == 1"
                                v-model="is_share_pass"
                                label="Share with Password"
                                color="orange"
                            ></v-switch>
                            <v-spacer></v-spacer>
                            <v-btn color="success" dark @click="shareNewProject">{{ current_project.is_shared ? dialog_unshare_text : dialog_share_text }}</v-btn>
                            <v-btn color="grey" text dark @click="dialog_share = false">Cancel</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                 <v-tooltip top v-if="showViewProject">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" fab dark small @click="viewProject" class="edit_project_button teal mr-2">
                            <i class="v-icon mdi mdi-view-carousel-outline"></i>
                        </v-btn>
                    </template>
                    <span>View Project</span>
                </v-tooltip>

                <v-dialog
                    v-model="dialog_remove"
                    width="500"
                    dark
                    overlay-opacity=".5"
                    overlay-color="#333"
                >
                    <template v-slot:activator="{ on: dialog, attrs }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn fab dark small v-bind="attrs" v-on="{ ...tooltip, ...dialog }" title="Delete Project" class="delete_project_button red ">
                                    <i class="v-icon mdi mdi-delete-empty-outline"></i>
                                </v-btn>
                            </template>
                            <span>Delete Project</span>
                        </v-tooltip>
                    </template>
                    <v-card>
                        <v-card-title class="headline dark justify-center">
                            Are you sure to delete this project?
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-actions class="justify-center">
                            <v-btn color="teofly_yes_button" dark @click="deleteProject(current_project.hashid)">Yes</v-btn>
                            <v-btn color="teofly_no_button" dark @click="dialog_remove = false">No</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </div>
        </v-col>
    </div>
</template>

<script>
export default {
    name: "ProjectEdit",
    props: ['id'],
    data () {
        return {
            showEditLayer:false,
            is_share_pass: false,
            shared_password: '',
            shared_url: '',
            showViewProject: false,
            dialog_layer_add: false,
            dialog_remove: false,
            dialog_edit: false,
            dialog_share: false,
            dialog_share_text: 'Share Project',
            dialog_unshare_text: 'UnShare Project',
            valid: false,
            newProjectName:'',
            newProjectDescription: '',
            nameRules: [
                v => !!v || 'Name cannot be empty'
            ],
            passwordRules: [
                v => !!v || 'Password is required',
                v => (v && v.length >= 6) || 'Password must be equal or than 6 characters'
            ],
            newLayerName: ''
        }
    },
    computed:{
        projects () {
            return this.$store.getters.projects;
        },
        current_project () {
            return this.$store.getters.currentProject;
        },
        user () {
            return this.$store.getters.user;
        },
        current_layer () {
            return this.$store.getters.currentLayer;
        },
        next_layer(){
            return this.$store.getters.layers_count;
        },
        inserted_layer(){
            return this.$store.getters.inserted_layer;
        },
        shared_main_url(){
            return this.$store.getters.sharedUrl;
        }
    },
    watch: {
        id: function (val) {
            this.newProjectName = this.current_project.name;
            this.newProjectDescription = this.current_project.description;
        },
        current_layer: function (val) {
            if (this.current_layer.layer.id != 0 && this.current_layer.documents.length != 0) this.showViewProject = true;
            else this.showViewProject = false;
            this.showEditLayer = true;
        },
        current_project: function (val) {
            this.newProjectName = this.current_project.name;
            this.newProjectDescription = this.current_project.description
            this.showEditLayer = true;
        }
    },
    methods: {
        shared_click(){
            if (this.current_project.is_shared == 1){
                if (this.current_project.shared_password != null) window.open(this.shared_main_url + 'pshare/' + this.current_project.shared_slug, '_blank');
                else window.open(this.shared_main_url + 'share/' + this.current_project.shared_slug, '_blank');
            }
        },
        prepareShared(){
            if (this.current_project.is_shared == 0){
                if (typeof this.$refs.form_share != 'undefined') this.$refs.form_share.reset();
                this.shared_password = '';
                this.is_share_pass = false;
                this.shared_url = 'Project not shared...';
            }
            else{
                this.shared_password = (this.current_project.shared_password != null ? this.current_project.shared_password : '');
                this.is_share_pass = (this.current_project.shared_password != null ? true : false);
                this.shared_url = (this.current_project.shared_password != null ? this.shared_main_url + 'pshare/' + this.current_project.shared_slug : this.shared_main_url + 'share/' + this.current_project.shared_slug);
            }
        },
        viewProject(){
            this.$router.push('/view/' + this.current_project.hashid + '/' + this.current_layer.layer.id);
        },
        deleteProject(hashid){
            this.$store.dispatch('deleteProject', hashid).then(() => {
                this.dialog_remove = false;
                this.$store.dispatch('getProjects').then(() => {
                    this.$router.push('/');
                });
            })
            .catch(() => {});
        },
        updateNewProject (){
            if (this.$refs.form.validate()){
                const project = {
                    name: this.newProjectName,
                    description: this.newProjectDescription,
                    hashid: this.id
                };
                this.$store.dispatch('updateNewProject', project)
                .then(() => {
                    this.dialog_edit = false;
                    this.$store.dispatch('getProjects').then(() => {
                        const prjkey = Object.keys(this.projects).find(k=>this.projects[k].hashid===this.id);
                        const lyrkey = Object.keys(this.projects[prjkey].layers).find(k=>this.projects[prjkey].layers[k].id===this.current_layer.layer.id);
                        this.projects[prjkey].active = true;
                        this.projects[prjkey].layers[lyrkey].active = true;
                        this.$store.dispatch('setCurrentProject', this.id);
                    });
                })
                .catch(() => {});
            }
        },
        cancelNewProject (){
            this.newProjectName = this.current_project.name;
            this.newProjectDescription = this.current_project.description;
            this.dialog_edit = false;
        },
        shareNewProject (){

            let share = 1;
            if (this.current_project.is_shared) share = 0;

            if (share && this.is_share_pass && !this.$refs.form_share.validate()) return;

            this.$store.dispatch('shareNewProject', {hashid: this.current_project.hashid, share: share, password: this.shared_password})
            .then(() => {
                if (!this.current_project.is_shared) this.dialog_share = false;
                else{
                    this.shared_url = (this.current_project.shared_password != null ? this.shared_main_url + 'pshare/' + this.current_project.shared_slug : this.shared_main_url + 'share/' + this.current_project.shared_slug);
                }
            })
            .catch(() => {});
        },
        copyToClipboard(text){
            navigator.clipboard.writeText(text);
            this.$store.dispatch('sendNotificaton', 'Copied to Clipboard');
        },
        addLayerOpen (){
            this.newLayerName = 'Layer ' + (+this.next_layer + 1);
            this.dialog_layer_add = true;
        },
        addNewLayer (){
            if (this.$refs.form.validate()){
                const layer = {
                    name: this.newLayerName,
                    hashid: this.current_project.hashid
                };
                this.$store.dispatch('addNewLayer', layer)
                .then(() => {
                    this.dialog_layer_add = false;
                    this.$refs.form.reset();

                    this.$store.dispatch('getProjects').then(() => {
                        const prjkey = Object.keys(this.projects).find(k=>this.projects[k].hashid===this.current_project.hashid);
                        const lyrkey = Object.keys(this.projects[prjkey].layers).find(k=>this.projects[prjkey].layers[k].id===this.inserted_layer);
                        this.projects[prjkey].active = true;
                        this.projects[prjkey].layers[lyrkey].active = true;
                        this.$store.dispatch('getCurrentLayer', {hashid: this.current_project.hashid, id: this.inserted_layer, show_geo: false});
                        this.$store.dispatch('setCurrentProject', this.current_project.hashid);
                    });
                })
                .catch(() => {});
            }
        },
    },
    created () {
        if (Object.keys(this.current_project).length != 0){
            this.newProjectName = this.current_project.name;
            this.newProjectDescription = this.current_project.description;
            this.showEditLayer = true;
        }
        if (this.current_layer.layer.id != 0 && this.current_layer.documents.length != 0) this.showViewProject = true;
    }
};
</script>
